import { useEffect, useState } from "react";
import http from "../../components/http";
import NavBar from "../../components/NavBar";
import { IProcesso } from "../../interfaces/processo.interface";
import CardProduzido from "../../components/Cards/CardProduzido";
import SectionGastosProdutivos from "../../components/Section/SectionGastosProdutivos";
import { useNavigate } from "react-router-dom";

export default function Produzidos() {
    const [processos, setProcessos] = useState<IProcesso[]>([]);
    const [showRastreabilidade, setShowRastreabilidade] = useState<boolean>(false);
    const [showGrafic, setShowGrafic] = useState<boolean>(false);
    const [processoSelecionado, setProcessoSelecionado] = useState<IProcesso | undefined>(undefined);

    const navigate = useNavigate();

    const buscarDados = async () => {
        const response = await http.get('processos');
        
        // Ordena os processos pela data de fim em ordem descendente
        const processosOrdenados = response.data.sort((a: IProcesso, b: IProcesso) => {
            const dataA = new Date(a.fim).getTime();
            const dataB = new Date(b.fim).getTime();

            return dataB - dataA;
        });

        setProcessos(processosOrdenados);
    }

    useEffect(() => {
        buscarDados();
    }, []);

    const infoRastreabilidade = (processo: IProcesso) => {
        navigate(`/rastreio/${processo.id}`)
    }

    const infoGastosProdutivos = (processo: IProcesso) => {
        setProcessoSelecionado(processo);
        setShowGrafic(true);
    }

    return (
        <main>
            <NavBar />

            {!showRastreabilidade && !showGrafic &&
                <div style={{width: '100%', display: 'flex', flexWrap: 'wrap', padding: '15px'}}>
                    {processos.map((processo) => (
                        <CardProduzido
                            key={processo.id}
                            processo={processo}
                            infoRastreabilidade={() => infoRastreabilidade(processo)}
                            infoGastosProdutivos={() => infoGastosProdutivos(processo)}
                        />
                    ))}
                </div>
            }

            { showGrafic &&
                <SectionGastosProdutivos processo={processoSelecionado} voltar={() => setShowGrafic(false)}/>
            }
        </main>
    )
}
